module.exports = __webpack_public_path__ + "img/ml-gruppe.b3681e4a.svg";